export default {
  studentAssignment: {
    id: "",
    classSection: null,
    studentAssignment: null,
    studentEnrollDetail: null,
    student: null,
    sectionNo: null,
    studentCode: null,
    remark: null,
    studentSendDate: null,
    isTeacherReceive: null,
    score: null,
    dueDate: null,
    uploadPath: null,
    uploadPathUri: null,
    uploadFileName: null,
  },

  studentAssignments: [],
  processing: false,
  error: null,
  success: null,
}



